__turbopack_context__.v({
  "chip": "image-teaser-module__h6ELGG__chip",
  "content": "image-teaser-module__h6ELGG__content",
  "cta": "image-teaser-module__h6ELGG__cta",
  "footnote": "image-teaser-module__h6ELGG__footnote",
  "headline": "image-teaser-module__h6ELGG__headline",
  "image-teaser": "image-teaser-module__h6ELGG__image-teaser",
  "media": "image-teaser-module__h6ELGG__media",
  "text": "image-teaser-module__h6ELGG__text",
});
